import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail } from "lucide-react";
export default function Footer() {
  const businessName = "Elyon Maintenance Inc.";
  const address = "Gig Harbor, WA";
  const phone = "(555) 123-4567";
  const email = "scho@elyonmaintenance.com";
  const description = "Elyon Maintenance Inc. is your premium one-stop shop for facility care, specializing in landscaping, painting, and professional janitorial services for residential and commercial clients.";
  const platformLinks = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "Our Services",
    href: "/OurServicesPage"
  }, {
    label: "Showcase",
    href: "/ShowcasePage"
  }, {
    label: "Get a Quote",
    href: "/HomePage"
  }];
  const resourceLinks = [{
    label: "Facility Care",
    href: "/OurServicesPage"
  }, {
    label: "Project Gallery",
    href: "/ShowcasePage"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "#"
  }, {
    icon: Twitter,
    href: "#"
  }, {
    icon: Instagram,
    href: "#"
  }, {
    icon: Linkedin,
    href: "#"
  }];
  return <section data-section-id="30894" id="footer" className="bg-secondary text-secondary-foreground py-16">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <img src="/img/elyon_logo_white.png" alt={businessName} className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-secondary-foreground/70 text-sm leading-relaxed max-w-xs">
              {description}
            </p>
            
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-bold text-lg text-accent tracking-tight">Services</h4>
            <ul className="flex flex-col gap-3">
              {platformLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-secondary-foreground/70 hover:text-accent transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-bold text-lg text-accent tracking-tight">Resources</h4>
            <ul className="flex flex-col gap-3">
              {resourceLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-secondary-foreground/70 hover:text-accent transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-bold text-lg text-accent tracking-tight">Contact</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-sm text-secondary-foreground/70">
                <MapPin className="size-5 text-accent shrink-0 mt-0.5" />
                <span>{address}</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-secondary-foreground/70"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone size-5 text-accent shrink-0" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg><Link to="tel:2069928139" className="hover:text-accent transition-colors duration-300">(206) 992-8139</Link></li>
              <li className="flex items-center gap-3 text-sm text-secondary-foreground/70">
                <Mail className="size-5 text-accent shrink-0" />
                <Link to={`mailto:${email}`} className="hover:text-accent transition-colors duration-300">
                  {email}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-secondary-foreground/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-secondary-foreground/60">
          <p>&copy; {new Date().getFullYear()} {businessName}. All rights reserved.</p>
          <Link to={`mailto:${email}`} className="hover:text-accent transition-colors duration-300">
            {email}
          </Link>
        </div>
      </div>
    </section>;
}